module.exports = __webpack_public_path__ + "static/img/AIRWALLEX_H5.78e2495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/AIRWALLEX_H5.png
// module id = i1+5
// module chunks = 34